// @ts-check
import { z } from 'zod';

import Permission from '@/store/modules/models/global/Permission';

import Group from '@/store/modules/users/models/Group';
import UserSummary from '@/store/modules/users/models/UserSummary';

const SharingSummary = z.object({
  groups: z.array(z.object({ group: Group, permission: Permission })),
  users: z.array(z.object({ user: UserSummary, permission: Permission })),
});

export default SharingSummary;
